export default __webpack_public_path__ + "static/media/lot.abe8eb57.png";